/** @module Classes */ /** typedoc */
class SplitVersion {
    constructor() {
        this.versionKey = null;
        this.sharePercentage = null;
    }
}

export { SplitVersion };
